import { saveAs } from "file-saver";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import ExcelApi from "../../../api/excel.api";
import LectureApi from "../../../api/lecture.api";
import AddBtn from "../../../component/atoms/button/addBtn";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import ExcelBtn from "../../../component/atoms/button/excelBtn";
import TableDelBtn from "../../../component/atoms/button/tableDelBtn";
import Checkbox from "../../../component/atoms/input/checkbox";
import SearchBar from "../../../component/atoms/input/searchBar";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Table from "../../../component/atoms/layout/table/table";
import TableFilter from "../../../component/atoms/layout/table/tableFilter";
import TableLayout from "../../../component/atoms/layout/table/tableLayout";
import TableSearchBtn from "../../../component/atoms/layout/table/tableSearchBtn";
import TableTop from "../../../component/atoms/layout/table/tableTop";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import PretendardText from "../../../component/atoms/text/pretendardText";
import TableText from "../../../component/atoms/text/table/tableText";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import Pagination from "../../../component/molecules/pagination";
import TableCount from "../../../component/molecules/tableCount";
import TableTab02 from "../../../component/molecules/tableTab02";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { tagList } from "../../../constants/tagList";
import { imgUrl } from "../../../constants/url";
import { route } from "../../../router/route";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";

const FinanceLecture = () => {
  const tabList = [
    {
      title: "금융 스터디",
      link: route.lecture_lecture_finance,
      originLink: route.lecture_lecture_finance,
    },
    {
      title: "유료 강의",
      link: route.lecture_lecture_paid,
      originLink: route.lecture_lecture_paid,
    },
  ];

  const [tagBoxOpen, setTagBoxOpen] = useState(false);
  const [categoryBoxOpen, setCategoryBoxOpen] = useState(false);

  const [categoryList, setCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("전체");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedTag, setSelectedTag] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  // ----------------------------------- //
  // ---------- 마운트가 되면 ---------- //
  // --------------------------------- //
  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    getProductList();
    getCategory();
  }, [location, selectedCategory, selectedTag]);

  const [lectureList, setLectureList] = useState([]);
  const [keyword, setKeyword] = useState("");

  const getProductList = async () => {
    try {
      let data = {
        keyword: searchParams.get("keyword"),
        page: searchParams.get("page"),
        size: pagination.size,
        lectureCategoryType: "FINANCE_STUDY",
        tag: selectedTag,
      };

      if (selectedCategoryId) {
        data.lectureCategoryId = selectedCategoryId;
      }

      let responseData = (await LectureApi.getLecture(data)).data.data;

      setLectureList(
        responseData.content.map((item) => {
          return {
            ...item,
            checked: false,
          };
        })
      );
      setPagination({
        ...pagination,
        totalCount: responseData.totalCount ? responseData.totalCount : 0,
        totalPages: Math.ceil(responseData.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const getCategory = async () => {
    try {
      const data = {
        lectureCategoryType: "FINANCE_STUDY",
      };

      let responseData = (await LectureApi.getCategory(data)).data.data.content;

      setCategoryList(responseData);
    } catch (error) {
      errorHandler(error);
    }
  };

  const [pagination, setPagination] = useState({
    size: 5, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 1,
    totalPages: 1,
  });

  const isAllCheck = useMemo(() => {
    const checkedList = lectureList.filter((item) => item.checked);
    return (
      checkedList.length !== 0 && checkedList.length === lectureList.length
    );
  }, [lectureList]);

  const [title, setTitle] = useState("강의 관리");
  const [subTitle, setSubTitle] = useState("항목");

  // ----- 활성/비활성
  const [filterOpen, setFilterOpen] = useState(-1);
  const [activationId, setActivationId] = useState(null);
  const [activation, setActivation] = useState(null);
  const [activationModalTitle, setActivationModalTitle] = useState("");
  const [activationModalOpen, setActivationModalOpen] = useState(false);

  const activationFunc = async () => {
    try {
      const data = {
        activation: activation,
      };
      await LectureApi.activation(activationId, data);
      toast(toastMsg.create);
      setFilterOpen(-1);
      setActivationModalOpen(false);
      getProductList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 삭제
  const [delIdList, setDelIdList] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: delIdList,
      };
      await LectureApi.delLecture(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      setDelIdList([]);
      getProductList();
    } catch (error) {
      errorHandler(error);
    }
  };

  //------------엑셀 생성
  const downloadExcel = async (excelData) => {
    const Excel = require("exceljs");
    const workbook = new Excel.Workbook();
    workbook.addWorksheet("Sheet One");
    const sheetOne = workbook.getWorksheet("Sheet One");

    sheetOne.columns = [
      { header: "강의명", key: "title", width: 40 },
      { header: "커리큘럼", key: "curriculumCount", width: 40 },
      { header: "수강인원", key: "studentCount", width: 40 },
      { header: "활성 상태", key: "activation", width: 40 },
    ];

    excelData.map((item) => {
      // 행 추가
      sheetOne.addRow(item);
    });
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "금융스터디 강의 관리.xlsx");
  };

  const getExcelAll = async () => {
    try {
      const excelArr = [];
      const response = (
        await ExcelApi.LectureVideoExcel({
          ids: [],
          allFlag: true,
          tag: selectedTag,
          lectureCategoryType: "FINANCE_STUDY",
          keyword: searchParams.get("keyword"),
          isFree: "Active",
          isPaid: "Inactive",
        })
      ).data.data.content;

      response.map((item) => {
        const activeTitle = item.activation ? "활성" : "비활성";
        excelArr.unshift({
          ...item,
          activation: activeTitle,
        });
      });

      downloadExcel(excelArr);
    } catch (error) {
      errorHandler(error);
    }
  };

  const getExcelChecked = async () => {
    const filter = lectureList.filter((item) => item.checked);
    if (filter.length <= 0) {
      return toast("항목을 선택해주세요");
    }

    try {
      const excelArr = [];
      const response = (
        await ExcelApi.LectureVideoExcel({
          ids: filter.map((item) => item.id),
          allFlag: false,
          tag: selectedTag,
          lectureCategoryType: "FINANCE_STUDY",
          keyword: searchParams.get("keyword"),
        })
      ).data.data.content;

      response.map((item) => {
        const activeTitle = item.activation ? "활성" : "비활성";
        excelArr.unshift({
          ...item,
          activation: activeTitle,
        });
      });

      downloadExcel(excelArr);
    } catch (error) {
      errorHandler(error);
    }
  };
  //------------액셀 부분 끝

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <TableLayout>
          <TableTitle>{title}</TableTitle>
          <TableTab02 list={tabList} style={{ marginBottom: "20px" }} />
          <TableTop>
            <TableCount text={subTitle} count={pagination.totalCount} />
            <TableSearchBtn>
              <div style={{ position: "relative", width: "130px" }}>
                <SelectBoxWrapper
                  onClick={() => {
                    setTagBoxOpen(!tagBoxOpen);
                  }}
                  style={{ cursor: "pointer", width: "130px" }}
                >
                  <PretendardText
                    style={{
                      color: "#808991",
                      fontSize: "15px",
                      fontWeight: "400",
                      lineHeight: "21.25px",
                    }}
                  >
                    {selectedTag || "태그"}
                  </PretendardText>
                  <img
                    src="/assets/admin/icons/ico_select_arrow_down.svg"
                    alt=""
                  />
                </SelectBoxWrapper>
                {tagBoxOpen ? (
                  <SubMenuWrapper style={{ width: "130px" }}>
                    {tagList.map((item, index) => {
                      return (
                        <SubMenuTextWrapper
                          key={index}
                          onClick={() => {
                            setSelectedTag(item);
                            // navigate(
                            //   `${route.lecture_lecture_finance}?page=1&keyword=${keyword}&categoryId=${selectedCategoryId}&tag=${item}`,
                            //   {
                            //     replace: true,
                            //   }
                            // );
                            setTagBoxOpen(false);
                          }}
                        >
                          <PretendardText
                            style={{
                              color: "#262C31",
                              fontSize: "15px",
                              fontWeight: "500",
                              lineHeight: "21.5px",
                            }}
                          >
                            {item}
                          </PretendardText>
                          {/* {partnerInfo.region === item.title ? (
                                <img
                                  src="/assets/admin/icons/ico_select_checked.svg"
                                  alt=""
                                />
                              ) : null} */}
                        </SubMenuTextWrapper>
                      );
                    })}
                  </SubMenuWrapper>
                ) : null}
              </div>
              <div style={{ position: "relative", width: "120px" }}>
                <SelectBoxWrapper
                  onClick={() => {
                    setCategoryBoxOpen(!categoryBoxOpen);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <PretendardText
                    style={{
                      color: "#808991",
                      fontSize: "15px",
                      fontWeight: "400",
                      lineHeight: "21.25px",
                    }}
                  >
                    {selectedCategory || "카테고리"}
                  </PretendardText>
                  <img
                    src="/assets/admin/icons/ico_select_arrow_down.svg"
                    alt=""
                  />
                </SelectBoxWrapper>
                {categoryBoxOpen ? (
                  <SubMenuWrapper>
                    <SubMenuTextWrapper
                      onClick={() => {
                        setSelectedCategory("전체");
                        setSelectedCategoryId("");
                        setCategoryBoxOpen(false);
                      }}
                    >
                      <PretendardText
                        style={{
                          color: "#262C31",
                          fontSize: "15px",
                          fontWeight: "500",
                          lineHeight: "21.5px",
                        }}
                      >
                        전체
                      </PretendardText>
                    </SubMenuTextWrapper>
                    {categoryList.map((item, index) => {
                      return (
                        <SubMenuTextWrapper
                          key={index}
                          onClick={() => {
                            setSelectedCategory(item.title);
                            setSelectedCategoryId(item.id);
                            setCategoryBoxOpen(false);
                          }}
                        >
                          <PretendardText
                            style={{
                              color: "#262C31",
                              fontSize: "15px",
                              fontWeight: "500",
                              lineHeight: "21.5px",
                            }}
                          >
                            {item.title}
                          </PretendardText>
                          {/* {partnerInfo.region === item.title ? (
                                <img
                                  src="/assets/admin/icons/ico_select_checked.svg"
                                  alt=""
                                />
                              ) : null} */}
                        </SubMenuTextWrapper>
                      );
                    })}
                  </SubMenuWrapper>
                ) : null}
              </div>
              <SearchBar
                style={{ width: "230px" }}
                inputStyle={{ width: "172px" }}
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(
                      `${route.lecture_lecture_finance}?page=1&keyword=${encodeURIComponent(keyword)}`,
                      {
                        replace: true,
                      }
                    );
                    setTitle("검색 결과");
                    setSubTitle("검색 결과");
                  }
                }}
                onClick={() => {
                  navigate(
                    `${route.lecture_lecture_finance}?page=1&keyword=${encodeURIComponent(keyword)}`,
                    {
                      replace: true,
                    }
                  );
                  setTitle("검색 결과");
                  setSubTitle("검색 결과");
                }}
              />
              <ExcelBtn
                onSelectClick={getExcelChecked}
                onAllClick={getExcelAll}
              />
              <AddBtn onClick={() => navigate(route.lecture_lecture_add)} />
            </TableSearchBtn>
          </TableTop>
          <Table>
            <colgroup>
              {/* 체크박스 영역 */}
              <col width="90px" />
              {/* 강의명 */}
              <col width="493px" />
              {/* 커리큘럼 */}
              <col width="80px" />
              {/* 수강 인원 */}
              <col width="80px" />
              {/* 결제 금액 */}
              <col width="101px" />
              {/* 활성 상태 */}
              <col width="113px" />
              {/* 삭제하기 */}
              <col width="95px" />
              {/* 상세보기 */}
              <col width="73px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setLectureList(
                          lectureList.map((item) => {
                            return {
                              ...item,
                              checked: true,
                            };
                          })
                        );
                      } else {
                        setLectureList(
                          lectureList.map((item) => {
                            return {
                              ...item,
                              checked: false,
                            };
                          })
                        );
                      }
                    }}
                  />
                </Th>
                <Th style={{ paddingLeft: "20px" }}>
                  <TableText>강의명</TableText>
                </Th>
                <Th>
                  <TableText>커리큘럼</TableText>
                </Th>
                <Th>
                  <TableText>수강 인원</TableText>
                </Th>
                <Th>
                  <TableText>결제 금액</TableText>
                </Th>
                <Th>
                  <TableText>활성 상태</TableText>
                </Th>
                <Th>
                  <TableText>삭제하기</TableText>
                </Th>
                <Th>
                  <TableText>상세보기</TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {lectureList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{ height: "124px", background: "#fff" }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={item.checked}
                        onChange={() => {
                          item.checked = !item.checked;
                          setLectureList([...lectureList]);
                        }}
                      />
                    </Td>
                    <Td style={{ paddingLeft: "20px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "23px",
                        }}
                      >
                        <img
                          style={{
                            width: "150px",
                            height: "94px",
                            borderRadius: "3px",
                          }}
                          src={imgUrl + item.thumbnailServerFileName}
                        />
                        <TitleText
                          style={{
                            width: "280px",
                          }}
                        >
                          {item.title}
                        </TitleText>
                      </div>
                    </Td>
                    <Td>
                      <TableText>{item.curriculumCount}강</TableText>
                    </Td>
                    <Td>
                      <TableText>{item.studentCount}명</TableText>
                    </Td>
                    <Td>
                      <TableText>{item.price.toLocaleString()}원</TableText>
                    </Td>
                    <Td>
                      <TableFilter
                        style={{
                          width: "75px",
                        }}
                        subStyle={{
                          top: "85px",
                        }}
                        onClick={() => {
                          filterOpen === index
                            ? setFilterOpen(-1)
                            : setFilterOpen(index);
                        }}
                        isOpen={filterOpen === index}
                        selectedValue={item.activation}
                        list={[
                          {
                            value: true,
                            title: "활성",
                            onClick: () => {
                              setActivationId(item.id);
                              setActivation(true);
                              setActivationModalTitle("활성화");
                              setActivationModalOpen(true);
                            },
                          },
                          {
                            value: false,
                            title: "비활성",
                            onClick: () => {
                              setActivationId(item.id);
                              setActivation(false);
                              setActivationModalTitle("비활성화");
                              setActivationModalOpen(true);
                            },
                          },
                        ]}
                      />
                    </Td>
                    <Td>
                      <TableDelBtn
                        style={{ marginLeft: "6px" }}
                        onClick={() => {
                          setLectureList([...lectureList]);
                          const delList = [item];
                          setDelIdList(delList.map((item) => item.id));
                          setDeleteModalOpen(true);
                        }}
                      />
                    </Td>
                    <Td>
                      <DetailBtn
                        onClick={() => {
                          navigate(route.lecture_lecture_info + `/${item.id}`);
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <Pagination
            route={route.lecture_lecture_finance}
            queryString={`keyword=${encodeURIComponent(searchParams.get("keyword") || "")}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
          />
        </TableLayout>
      </MainLayout>

      {activationModalOpen ? (
        <Modal
          title={`${activationModalTitle} 하시겠습니까?`}
          setModalOpen={setActivationModalOpen}
          onClick={() => {
            activationFunc();
          }}
        />
      ) : null}

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}
    </>
  );
};

export default FinanceLecture;

const TitleText = styled(PretendardText)`
  width: 290px;
  color: #778088;
  font-size: 14px;
  font-weight: 500;
  line-height: 22.75px;

  overflow: hidden; /* 텍스트 넘침 방지 */
  display: -webkit-box; /* 플렉스 박스 유사 동작 */
  -webkit-line-clamp: 2; /* 두 줄까지만 표시 */
  -webkit-box-orient: vertical; /* 텍스트 수직 정렬 */
  text-overflow: ellipsis; /* 넘치는 텍스트에 말줄임표 추가 */
  word-break: break-word; /* 긴 단어도 적절히 줄바꿈 */
`;

const SelectBoxWrapper = styled.div.attrs((props) => {})`
  width: 120px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 15px;
  border-radius: 4px;
  border: 1px solid #adb4ba;
  background: #fff;
`;

const SubMenuWrapper = styled.div.attrs((props) => {})`
  width: 120px;
  max-height: 200px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 4px 20px 0px rgba(10, 13, 20, 0.15);
  position: absolute;
  top: 50px;
  right: 0;
  padding: 10px;
  overflow-y: auto;
  z-index: 5;

  &::-webkit-scrollbar {
    width: 15px;
  }

  &::-webkit-scrollbar-thumb {
    background: #b0b8c1; /* 스크롤바의 색상 */
    border-radius: 9px;
    background-clip: padding-box;
    border: 6px solid transparent;
  }

  &::-webkit-scrollbar-track {
    background: transparent; /*스크롤바 뒷 배경 색상*/
  }
`;

const SubMenuTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 42px;
  padding: 10px;
  cursor: pointer;
  border-radius: 3px;

  &:hover {
    background-color: #f2f4f5;
  }
`;
